/**
 * @fileOverview Slider.
 * @author Selectra Front End Team
 * @version 1.0.0
 * @requires Polyfill:array_from 'array-from'
 * @requires Polyfill:element_prototype_classlist 'classlist'
 */

import BaseCarousel from './base-carousel';

export default class Slider extends BaseCarousel {

  goNext() {
    if ( this.states.isAnimating ) {
      return false;
    }
    let repeat = this.getOption( 'slideBy' ) === 'page' ? this.getOption( 'items' ) : this.getOption( 'slideBy' ),
      rewind = true;
    for ( let ii = 1; ii <= repeat; ii++ ) {
      if (( this.states.referenceSlide > ( this.states.slidesNumber - 1 - this.previousCloneSlides.length )) && rewind ) {
        // this.states.listNodeTransformPosition += -100
        this._removeTransition()
        this.states.referenceSlide = 0 - ( this.states.slidesNumber - this.states.referenceSlide );
        this._movePosition()
        this._renderPosition()
        this.listNode.clientWidth;
      } else {
        rewind = false;
      }
      this._setTransition();
      this.states.referenceSlide += 1;
      this._movePosition();
    }
    this._lockTransition();
    this._renderPosition();
  }

  goPrevious() {
    if ( this.states.isAnimating ) {
      return false;
    }
    let repeat = this.getOption( 'slideBy' ) === 'page' ? this.getOption( 'items' ) : this.getOption( 'slideBy' ),
      rewind = true;
    for ( let ii = 1; ii <= repeat; ii++ ) {
      if (( this.states.referenceSlide < 0 ) && rewind ) {
        this._removeTransition()
        this.states.referenceSlide = this.states.slidesNumber - Math.abs( this.states.referenceSlide );
        this._movePosition()
        this._renderPosition()
        this.listNode.clientWidth;
      } else {
        rewind = false;
      }

      this._setTransition()
      this.states.referenceSlide -= 1
      this._movePosition()
    }
    this._lockTransition();
    this._renderPosition()
  }

  initializeOptions( options ) {
    super.initializeOptions( options );
    this.options = {
      // Parent class options
      ...this.options,
      speed: options.speed || 500,
    }
    return options;
  }

  initializeStates( options ) {
    super.initializeStates( options );
    this.states = {
      // parent class states
      ...this.states,
      isAnimating: false,
    }
  }


  attach() {
    super.attach();
    this._attachTransition();
  }
  run() {
    super.run()
    this._setTransition();
  }

  _attachTransition() {
    this.listNode.addEventListener( 'transitionend', this._onTransitionEnd.bind( this ));
  }

  _buildCarouselContainer() {
    super._buildCarouselContainer();
    this.carouselNode.classList.add( 'carousel--slider' )
  }

  _buildNextCloneSlides() {
    let start = 0,
      end = this.getOption( 'items' ) + 1;
    this.nextCloneSlides = this.slides.slice( start, end );
    this.nextCloneSlides = this.nextCloneSlides.map(( slide ) => {
      slide = slide.cloneNode( true );
      slide.classList.add( 'carousel__item--clone' );
      slide.classList.add( 'carousel__item--next' );
      return slide;
    })
  }

  _buildPreviousCloneSlides() {
    let start = this.states.slidesNumber - this.getOption( 'items' ) - 1;
    this.previousCloneSlides = this.slides.slice( start ).reverse();
    this.previousCloneSlides = this.previousCloneSlides.map(( slide ) => {
      slide = slide.cloneNode( true );
      slide.classList.add( 'carousel__item--clone' );
      slide.classList.add( 'carousel__item--clone-previous' );
      slide.classList.remove( 'js-is--reference' );
      return slide;
    })
  }

  _removeTransition() {
    this.listNode.style.transition = '';
  }

  _setTransition() {
    this.listNode.style.transition = `transform ${this.getOption( 'speed' )}ms ease-in-out`;
  }

  _setNavActiveSlide() {
    if ( this.getOption( 'nav' )) {
      let number,
        targetButton;
      Array.from( this.navNode.children ).forEach(( button ) => {
        button.classList.remove( 'js-is-ref' )
      })

      // If reference slide is not a clone
      if ( this.states.referenceSlide >= 0 && this.states.referenceSlide < this.states.slidesNumber - this.nextCloneSlides.length ) {

        // If slideBy is a number
        if ( !isNaN( this.getOption( 'slideBy' ))) {
          number = this.states.referenceSlide;
        } else {
          // If slideBy is a string
          number = this.states.referenceSlide;
        }
      } else if ( Math.sign( this.states.referenceSlide ) == -1 ) {
        // If Reference slide is a "previousClone"
        number = this.states.slidesNumber + this.states.referenceSlide;
      } else if ( Math.sign( this.states.referenceSlide ) == 1 ) {
        // If Reference slide is a "nextClone"
        number = 0 + this.states.referenceSlide;
      } else if ( this.states.referenceSlide == 0 && this.getOption( 'items' ) == 1 ) {
        // If Reference slide is 0 and with only 1 slide active
        number = 0;
      }

      // Avoid error to stop transition
      if ( !isNaN( number )) {
        number = this._getNearestNavNumber( number );
        targetButton = this.navNode.querySelector( `.carousel__navigation-item--${number}` );
        targetButton.classList.add( 'js-is-ref' );
      }
    }
  }

  _getNearestNavNumber( number ) {
    while (( !this.navNode.querySelector( `.carousel__navigation-item--${number}` )) && ( number >= 0 )) {
      number--;
    }

    return number;
  }

  _lockTransition() {
    this.states.isAnimating = true;
  }

  _unlockTransition() {
    this.states.isAnimating = false;
  }

  _onTransitionEnd() {
    this._unlockTransition();
  }
}
